var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Arrow_Down",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9796 1.24166L7.11874 6.10251L2.25789 1.24166C1.7693 0.753066 0.980034 0.753066 0.491443 1.24166C0.00285235 1.73025 0.00285235 2.51951 0.491443 3.0081L6.24178 8.75843C6.73037 9.24703 7.51963 9.24703 8.00822 8.75843L13.7586 3.0081C14.2471 2.51951 14.2471 1.73025 13.7586 1.24166C13.27 0.765594 12.4682 0.753066 11.9796 1.24166Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.67ab47cf.svg";
export { ForwardRef as ReactComponent };